// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
const COLORS = {
  Black: '#000000',
  Black2: '#444444',
  Black3: '#575757',
  Black4: '#707070',
  Gray: '#909090',
  Gray1: '#646464',
  White4: '#BBBBBB',
  White3: '#DFDFDF',
  White2: '#F9F9F9',
  White: '#FFFFFF',
  Orange: '#EF8200',
  Orange2: '#FCA032',
  Orange3: '#FFB300',
  Orange4: '#F0B125',
  Orange5: '#FFC84F',
  Orange6: '#FFC076',
  GradientOrange: 'linear-gradient(180deg, #EF8200 0%, #FF9B22 100%)',
  Red: '#FF5B5B'
}

export type ColorType = 'Black' | 'Black2' | 'Black3' | 'Black4' | 'Gray' | 'Gray1' | 'White4' | 'White3' | 'White2' | 'White' | 'Orange' | 'Orange2' | 'Orange3' | 'Orange4' | 'Orange5' | 'Orange6' | 'GradientOrange' | 'Red' ;

export function getColor(color: ColorType) {
  return COLORS[color];
}

export interface ColorProps {
  color?: ColorType;
}

export function color({ color }: ColorProps) {
  if (color) {
    return `color: ${getColor(color)};`
  }
}

export interface HoverColorProps {
  hoverColor?: ColorType;
}

export function hoverColor({ hoverColor }: HoverColorProps) {
  if (hoverColor) {
    return `&:hover { color: ${getColor(hoverColor)}; }`
  }
}

export interface BackgroundColorProps {
  backgroundColor?: ColorType;
}

export function backgroundColor({ backgroundColor }: BackgroundColorProps) {
  if (backgroundColor) {
    return `background-color: ${getColor(backgroundColor)};`
  }
}

export interface BorderColorProps {
  borderColor?: ColorType;
}

export function borderColor({ borderColor }: BorderColorProps) {
  if (borderColor) {
    return `border-color: ${getColor(borderColor)};`
  }
}
